import tagModel from "../../../../models/custom-vision/custom-vision.tags.model";
import ViewBase from '../../../view-base.view';
import CommonFooterComponent from '../common-footer.component';

export default function CVTagAddView() {
  ViewBase.call(this);

  let inputDataModel = { tagName: "", tagDescription: "" };
  let selectedProjectId = 0;
  let listOfTags = [];

  let _onPopupClose = (e) => { };
  let _onSaveComplete = (e) => { };

  let _cancel = (e) => {
    _onPopupClose(e);
  }

  let _save = (e) => {
    // Form validation
    if (!this.validateForm(e)) {
      return false;
    }

    tagModel.createNewTag(
      (result) => {
        _onSaveComplete(result);
      },
      (error) => {
        this.handleError(error);
      },
      listOfTags,
      selectedProjectId,
      inputDataModel.tagName,
      inputDataModel.tagDescription
    );
  }

  let _getTagName = (e) => {
    inputDataModel.tagName = e.target.value;
  }

  let _getTagDescription = (e) => {
    inputDataModel.tagDescription = e.target.value;
  }

  return {
    oninit: function (vnode) {
      if (vnode.attrs.onPopupClose) {
        _onPopupClose = vnode.attrs.onPopupClose;
      }

      if (vnode.attrs.onSaveComplete) {
        _onSaveComplete = vnode.attrs.onSaveComplete;
      }

      if (vnode.attrs.projectId) {
        selectedProjectId = vnode.attrs.projectId;
      }

      if (vnode.attrs.listOfTags) {
        listOfTags = vnode.attrs.listOfTags;
      }

    },
    view: () => {
      return [
        m('.row',
          m('col-md-12',
            m('.card',
              m('.card-body',
                m('form#mainFormTag[novalidate].needs-validation',
                  m('.row.col-md-12',
                    m('.col-md-12.mt-4',
                      m('label.form-label', this.getText("LT00000134", "Tag"), m('span.redText', "*")),
                      m('input[required][maxlength=50][type=text][placeholder=' + this.getText("LT00000134", "Tag") + '][value="' + inputDataModel.tagName + '"].form-control.form-control-bg.text-uppercase', { onchange: _getTagName }),
                      m('.invalid-feedback', this.getText("LT00000376", "Please enter a name for the tag."))
                    ),
                    m('.col-md-12.mt-4',
                      m('label.form-label', this.getText("LT00000012", "Description")),
                      m('textarea#txtContent.form-control.form-control-bg',
                        {
                          placeholder: this.getText("LT00000012", "Description"),
                          onchange: _getTagDescription,
                          style: "height: 185px;",
                          maxlength: 255
                        },
                        inputDataModel.tagDescription
                      )
                    )
                  )

                ),
                m(CommonFooterComponent, {
                  actionHandler: _save,
                  cancelHandler: _cancel,
                }),
              )
            )
          ),
        ),
        this.getBaseViews()
      ];
    },
  };
}
